import type { FC } from "react";

import { useHistory } from "react-router";

import { Alert, Button, Text } from "@alpacahq/ui/old";

import { useGetIsLegalEntity } from "~/v2/api/hooks";
import { Path } from "~/v2/path";
import { useAccountContext } from "~/v2/providers/AccountProvider";

const ENTITY_ACCOUNT_OPTIONS_APPLICATION_URL =
  "https://s3.amazonaws.com/files.alpaca.markets/disclosures/library/Options%20Account%20Application%20and%20Agreement%20-%20Legal%20Entity.pdf";

export const OptionsOptInEntityAccount: FC = () => {
  const history = useHistory();
  const { currentAccount } = useAccountContext({ liveOnly: true });
  const { isLegalEntity, isLegalEntityLoading } = useGetIsLegalEntity();

  const isLevel1Approved = currentAccount?.options_approved_level === 1;

  const onClickDownload = () =>
    window.open(ENTITY_ACCOUNT_OPTIONS_APPLICATION_URL, "_blank", "noopener");

  if (
    (currentAccount && !isLegalEntity && !isLegalEntityLoading) ||
    currentAccount?.options_approved_level === 2
  ) {
    history.replace(Path.ROUTE_DASHBOARD);
  }

  return (
    <div className="pr-8 pl-8 md:pl-0">
      <h1 className="pb-8 font-bold text-3xl">
        Options Trading for Entity Accounts
      </h1>
      {isLevel1Approved && (
        <Alert
          message="Your account is approved for level 1 options trading, see below to apply for level 2."
          variant="info"
          className="mb-4 max-w-lg"
        />
      )}
      <Text>
        Entity accounts require an additional manual application and review for
        approval.
      </Text>
      <Text>
        Please complete the attached document and return to{" "}
        <a href="mailto:support@alpaca.markets">support@alpaca.markets</a>.
      </Text>
      <br />
      <Text>
        Email <a href="mailto:support@alpaca.markets">support@alpaca.markets</a>{" "}
        with any questions on completing the application.
      </Text>
      <Button className="my-4" onClick={onClickDownload}>
        Download Options Application
      </Button>
    </div>
  );
};

export default OptionsOptInEntityAccount;
